import React, { Component } from 'react'
import Card from '../card'
import * as styles from './posts.module.css'

export default class Posts extends Component {

  render() {
    const posts = this.props.posts
    return (
      <div>
        <div className={styles.posts_contents}>
          {posts.map((post, index) => {
            return (
              <Card post={post} key={index} />
            )
          })}
        </div>
      </div>
    )
  }
}